for (let index = 0; index < document.querySelectorAll(".applicationInput").length; index++) {
    const element = document.querySelectorAll(".applicationInput")[index];
    element.onfocus = function () {
        element.parentNode.classList.add("active")        
       
    }
    element.onblur = function () {
        if (!(element.value)) { 
            element.parentNode.classList.remove("active")      
        }  
    }
}